import React, { useContext } from 'react'
import { ProjectContext } from '../../../../context/ProjectContext'
import { StarsFilter } from '../filters/stars'
import { MeetingsFilter } from '../filters/meetings'
import { CategoriesFilter } from '../filters/categories'
import { SortFilter } from '../filters/sortFilter'
import { Notes } from '../../needs/notes'
import { DeleteNotesDialog } from '../../needs/deleteNotesDialog'
import { createPortal } from 'react-dom'

export function Needs() {
  const {
    filteredNotes,
    needsFilters,
    setNeedsFilters,
    showDeleteNotesDialog,
    setShowDeleteNotesDialog,
    handleDeleteNotes,
    selectedNotes,
  } = useContext(ProjectContext)

  return (
    <div className="w-full bg-white rounded-xl p-8 shadow-sm border border-[#e4e4e4]">
      <div className="pb-8 border-b border-[#e4e4e4]">
        <p className="text-[#3f424a] text-4xl font-bold font-['DM_Sans'] leading-[41.40px]">Needs</p>
      </div>

      <div
        className="w-full h-12 mt-[20px] mb-[6px] bg-white rounded-[10px] flex items-center"
        style={{ boxShadow: '0px 0px 16px 8px rgba(0, 0, 0, 0.15)' }}
      >
        <StarsFilter filters={needsFilters} setFilters={setNeedsFilters} label={'Needs'} />
        <CategoriesFilter filters={needsFilters} setFilters={setNeedsFilters} />
        <MeetingsFilter filters={needsFilters} setFilters={setNeedsFilters} />
        <SortFilter filters={needsFilters} setFilters={setNeedsFilters} />
        {/* <TagsFilter /> */}
      </div>

      <div className="w-full flex flex-wrap relative">
        <Notes notes={filteredNotes} />
      </div>

      {showDeleteNotesDialog &&
        createPortal(
          <DeleteNotesDialog
            handleDeleteNotes={handleDeleteNotes}
            notesCount={selectedNotes.length}
            handleClose={() => setShowDeleteNotesDialog(false)}
          />,
          document.body
        )}
    </div>
  )
}
